'use strict';

var cov_1psij6tm11 = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\account\\account.js',
      hash = '434171fc289cc0e6b09e859a6d4de6f5b484162a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\account\\account.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 30
        }
      },
      '1': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 33,
          column: 6
        }
      },
      '2': {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 13,
          column: 7
        }
      },
      '3': {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 40
        }
      },
      '4': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 16,
          column: 7
        }
      },
      '5': {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 37
        }
      },
      '6': {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 19,
          column: 7
        }
      },
      '7': {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 40
        }
      },
      '8': {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 25,
          column: 24
        }
      },
      '9': {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 32,
          column: 9
        }
      },
      '10': {
        start: {
          line: 27,
          column: 10
        },
        end: {
          line: 29,
          column: 13
        }
      },
      '11': {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 52
        }
      },
      '12': {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 45
        }
      },
      '13': {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 42,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 98
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 9,
            column: 30
          },
          end: {
            line: 9,
            column: 31
          }
        },
        loc: {
          start: {
            line: 9,
            column: 54
          },
          end: {
            line: 33,
            column: 5
          }
        },
        line: 9
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 26,
            column: 35
          },
          end: {
            line: 26,
            column: 36
          }
        },
        loc: {
          start: {
            line: 26,
            column: 41
          },
          end: {
            line: 30,
            column: 7
          }
        },
        line: 26
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 27,
            column: 56
          },
          end: {
            line: 27,
            column: 57
          }
        },
        loc: {
          start: {
            line: 27,
            column: 67
          },
          end: {
            line: 29,
            column: 11
          }
        },
        line: 27
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 30,
            column: 9
          },
          end: {
            line: 30,
            column: 10
          }
        },
        loc: {
          start: {
            line: 30,
            column: 15
          },
          end: {
            line: 32,
            column: 7
          }
        },
        line: 30
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        }, {
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        }],
        line: 11
      },
      '1': {
        loc: {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 16,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 16,
            column: 7
          }
        }, {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 16,
            column: 7
          }
        }],
        line: 14
      },
      '2': {
        loc: {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        }, {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        }],
        line: 17
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountController = function AccountController($scope, moment, $http, apiOpen, $rootScope, $window, myVars, $location, $mdDialog) {
  _classCallCheck(this, AccountController);

  cov_1psij6tm11.f[0]++;
  cov_1psij6tm11.s[0]++;

  $scope.checkinfo = myVars;
  // $scope.huy = function (packageid) {
  //   $http.post(apiOpen + 'huy/' + packageid).then(results => {
  //     $window.location = results.data.message;
  //   });
  // };
  cov_1psij6tm11.s[1]++;
  $scope.showCancelDialog = function (ev, packageid) {
    cov_1psij6tm11.f[1]++;

    var package_name;
    cov_1psij6tm11.s[2]++;
    if (angular.equals(packageid, 1)) {
      cov_1psij6tm11.b[0][0]++;
      cov_1psij6tm11.s[3]++;

      package_name = 'Triệu phú vina';
    } else {
      cov_1psij6tm11.b[0][1]++;
    }
    cov_1psij6tm11.s[4]++;
    if (angular.equals(packageid, 2)) {
      cov_1psij6tm11.b[1][0]++;
      cov_1psij6tm11.s[5]++;

      package_name = 'Vina quay số';
    } else {
      cov_1psij6tm11.b[1][1]++;
    }
    cov_1psij6tm11.s[6]++;
    if (angular.equals(packageid, 3)) {
      cov_1psij6tm11.b[2][0]++;
      cov_1psij6tm11.s[7]++;

      package_name = 'Ẩn số tri thức';
    } else {
      cov_1psij6tm11.b[2][1]++;
    }
    var confirm = (cov_1psij6tm11.s[8]++, $mdDialog.confirm().title('Quý khách có muốn hủy gói ' + package_name).textContent('').targetEvent(ev).ok('Có').cancel('Không'));
    cov_1psij6tm11.s[9]++;
    $mdDialog.show(confirm).then(function () {
      cov_1psij6tm11.f[2]++;
      cov_1psij6tm11.s[10]++;

      $http.post(apiOpen + 'huy/' + packageid).then(function (results) {
        cov_1psij6tm11.f[3]++;
        cov_1psij6tm11.s[11]++;

        $window.location = results.data.message;
      });
    }, function () {
      cov_1psij6tm11.f[4]++;
      cov_1psij6tm11.s[12]++;

      $state.go('app', {}, { reload: true });
    });
  };
};

cov_1psij6tm11.s[13]++;


angular.module('app').component('account', {
  templateUrl: 'app/account/account.html',
  controller: AccountController
});